<template>
  <div
    v-if="getAuthorityShowAI"
    :class="{
      'ai-helper-container': true,
      'ai-mask': visibleSlideBar || visibleFullScreen
    }"
  >
    <AiIcon
      v-if="showAI && showAIIcon && !ifClose"
      @mousedown.native="mousedownIcon"
      @mouseup.native="mouseupIcon"
    />
    <!-- <div
      v-if="showAI"
      id="aiSideId"
      ref="aiSideRef"
      :class="{
        'express-entrance': true,
        flex: true,
        'items-center': true,
        'cursor-pointer': true,
        'express-entrance-hover': !isMoveAIIcon && !isShowInletAI,
        hideAfter: isMoveAIIcon
      }"
      title="快捷键：CTRL+M"
      @click="handleClickEnterAiHelper"
      @mousedown="mousedownIcon"
    >
      <div class="entrance-item">
        <img class="icon" src="@/assets/image/aigc/icon.png" alt="">
        <img class="hovericon" src="@/assets/image/aigc/hovericon.png" alt="">
        <i class="el-icon-error hover-close" @click="closeAI" />
      </div>
    </div> -->
    <SlideBar v-if="visibleSlideBar" />
    <FullScreen v-if="visibleFullScreen" ref="fullScreen" />
    <inletAI
      v-if="isShowInletAI && getAuthorityShowAI"
      @ok="isShowInletAI = false"
    />
    <CopyContentDetectionDialog v-if="getAuthorityShowAI" />
  </div>
</template>
<script>
import hotkeys from 'hotkeys-js'
import SlideBar from './SlideBar/index.vue'
import FullScreen from './FullScreen/index.vue'

import eventBus from '@/utils/eventBus'
import {
  generatRandomKey,
  encryptRequestBody,
  encryptSymmetricKey
} from '@/utils/crypto'
import AiIcon from '@/components/AIHelper/components/AiIcon/index.vue'
import inletAI from '@/components/AIHelper/components/guides/inletAI.vue'
import { mapGetters, mapState } from 'vuex'
import {
  getHistory,
  getEnableModels,
  conversationNew,
  wsOnErrorEvent
} from '@/api/aigc'
import { getShortcutKeys } from '@/api/shortcutKey'
import CopyContentDetectionDialog from '@/components/CopyContentDetectionDialog/index.vue'
// import { aiSessionTemplatePage } from '@/api/aigc/standardIssueConfig'
import { getMyAssistantUsedList } from '@/api/aigc/index.js'
import { PopupManager } from 'element-ui/src/utils/popup'
import { EnableModels } from '@/api/aigc/chatExtract'
import organConfig from '@/utils/organConfig'
export default {
  components: {
    SlideBar,
    FullScreen,
    inletAI,
    AiIcon,
    CopyContentDetectionDialog
  },
  // 为组件注入父级方法/实例/属性
  provide() {
    return {
      /**
       * 全屏
       */
      activeFullScreen: this.activeFullScreen,
      /**
       * 打开小屏
       */
      openSlideBar: this.openSlideBar,
      /**
       * 关闭全屏
       */
      closeFullScreen: this.closeFullScreen,
      /**
       * 关闭小屏
       */
      closeSlideBar: this.closeSlideBar,
      /**
       * 关闭所有
       */
      closeALL: this.closeALL,
      /**
       * 是否全屏
       */
      isFullScreen: this.getIsFullScreen,
      /**
       * 获取聊天消息
       */
      getChatMessageList: this.getChatMessageList,
      /**
       * 新增聊天消息
       */
      setChatMessage: this.setChatMessage,
      /**
       * 清空聊天消息
       */
      clearChatMessage: this.clearChatMessage,
      /**
       * 获取聊天助手
       */
      getTypeAIList: this.getTypeAIList,
      /**
       *  ws实例
       */
      getWS: this.getWS,
      /**
       * 创建WebSocket
       */
      createWS: this.createWS,
      /**
       * 设置禁用输入框
       */
      setDisabledInput: this.setDisabledInput,
      /**
       * 获取禁用输入框值
       */
      getDisabledInput: this.getDisabledInput,
      /**
       * 获取显示重启会话按钮
       */
      getIsRestart: this.getIsRestart,
      /**
       * 设置显示重启会话按钮
       */
      setIsRestart: this.setIsRestart,

      /**
       *  修改聊天消息对象 -自定义修改字段
       */
      setIndexChatCustomKeyMessage: this.setIndexChatCustomKeyMessage,
      /**
       * 删除聊天消息对象
       */
      removeChatMessageItem: this.removeChatMessageItem,
      /**
       * 重置聊天消息对象-TmpIsOk属性
       */
      resetChatMessageListTmpIsOk: this.resetChatMessageListTmpIsOk,
      /**
       * 获取历史记录
       */
      getHistory: this.getHistory,
      /**
       * 刷新列表
       */
      setTypeAIList: this.setTypeAIList,
      /**
       * 获取ai回答结束标识
       */
      getIsAIEnd: this.getIsAIEnd,
      /**
       * 设置ai回答结束标识
       */
      setIsAIEnd: this.setIsAIEnd,
      /**
       * 关闭ws
       */
      closeWS: this.closeWS,
      setTmpMessage: this.setTmpMessage,
      /**
       * 设置模型类型
       */
      setModelType: this.setModelType,
      /**
       * 获取模型类型
       */
      getModelType: this.getModelType,
      /**
       * 获取模型列表
       */
      getModelList: this.getModelList,
      /**
       * 获取自定义列表
       */
      openCustomComponent: this.openCustomComponent,
      /**
       * 设置新闻列表
       */
      setNewsList: this.setNewsList,
      /**
       * 获取新闻列表
       */
      getNewsList: this.getNewsList,
      /**
       * 重置AI
       */
      resetSessionAI: this.resetSessionAI,
      initPage: this.init,
      /**
       * 使用对应的ui，用于助手中心
       */
      useAssistant: this.useAssistant,
      /**
       * 心跳监听
       */
      ws_heartCheck: this.ws_heartCheck,
      getEnableModels: this.getEnableModels,
      setHints: this.setHints,
      getPageIndex: this.getPageIndex,
      getRealConversationId: this.getRealConversationId
    }
  },
  data() {
    return {
      zIndex: 2000,
      showAI: true,
      visibleSlideBar: false,
      real_conversation_id: '',
      visibleFullScreen: false,
      ws: null,
      typeAIList: [],
      permsList: this.$route?.meta?.permsList || [],
      /**
       * 聊天消息列表
       * @type {Array}
       * @property {String} type 消息类型
       * type: 'welcome' /'ai' /'user'/'customTmp'
       * @property {String} text 消息内容
       * @property {String} status  消息状态  PENDING: 发送中 DONE: 发送完成
       */
      chatMessageList: [],
      disabledInput: false,
      isRestart: false,
      pageIndex: 1,
      // 热键冲突设置
      hotkeysConflictSettings: [],
      // 不需要显示助手的路由
      notRouters: ['/login', '/auth-redirect', '/loginByPassword', '/404'],
      // 有助手但是没有图标的路由
      notIconRouter: ['/ai/share'],
      isAIEnd: true,
      // 临时消息存储
      tmpMessage: null,
      intervalAI: undefined,
      // 拼接时字符串下标 拼接完成后清空
      joinIndex: 0,
      modelType: undefined,
      modelList: [],
      newsList: [],
      isMoveAIIcon: false,
      oldY: 0,
      oldX: 0,
      isShowInletAI: false,
      aiZhiyun: {
        backgroundColor: '#CFF3FF',
        content: '无',
        count: 1,
        createdNickName: null,
        createTime: '2023-11-21 11:40:33',
        description: '全能AI小助手，解决你的所有问题！',
        icon: `${organConfig.ossUrl}/hok_product/video/img_v3_0263_d6185f8b-c4cf-4a35-87d3-da0fbcf117dg.png`,
        templateId: '1',
        isEnabled: true,
        isPrivate: false,
        issueList: null,
        jobNameList: null,
        sort: 0,
        textColor: '#00ADFF',
        title: '智云',
        topSort: null,
        topTime: null,
        type: 1,
        useCounter: ''
      },
      ws_heartCheck: {
        timeout: 30000, // 30秒一次心跳
        timeoutObj: null, // 执行心跳的定时器
        serverTimeoutObj: null, // 服务器超时定时器
        reset: function () {
          // 重置方法
          console.log('清空心跳定时器')
          clearTimeout(this.timeoutObj)
          clearTimeout(this.serverTimeoutObj)
          return this
        },
        start: function (ws) {
          // 启动方法
          // var self = this
          this.timeoutObj = setTimeout(function () {
            // 这里发送一个心跳信息，后端收到后，返回一个消息，在onmessage拿到返回的心跳（信息）就说明连接正常
            ws.send(
              JSON.stringify({
                user: 'check',
                scene_id: -1,
                llm_type: -1,
                qa_mode: 'check',
                chat_template: null
              })
            )
            console.log('发送心跳包')
            // 如果超过一定时间还没重置，说明后端主动断开了
            // self.serverTimeoutObj = setTimeout(function() {
            // 如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
            // ws.close()
            // }, self.timeout)
          }, this.timeout)
        }
      },
      // 切换模型 语料库
      Hints: {},
      thinkList: '',
      textList: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'permission_routes']),
    ...mapState({
      roles: state => state.permission.addRouters,
      ifClose: state => state.ai.ifClose,
      showAi: state => state.ai.showAi
    }),
    getTypeAIList() {
      return this.typeAIList
    },
    getChatMessageList() {
      return this.chatMessageList
    },
    getAuthorityShowAI() {
      // return true
      // WEBPERMISSION
      const info = this.permission_routes?.find(v => v.path === 'component')
      let isPermission = false
      if (info) {
        isPermission = info.meta
          ? info.meta.permsList.filter(f => f === 'system:ai:assistant')
            .length > 0
          : false
      }
      return (
        this.notRouters.indexOf(this.$route.path) === -1 &&
        !!this.$store.getters.token &&
        isPermission
      )
    },
    getIsShowDouyinBZhangGuide() {
      return this.getTypeAIList.find(
        item => item.checked && item.assistantType === 'VideoExtract'
      )
    },
    showAIIcon() {
      return this.notIconRouter.indexOf(this.$route.path) === -1
    },
    viewerZIndex() {
      const nextZIndex = PopupManager.nextZIndex()
      return this.zIndex > nextZIndex ? this.zIndex : nextZIndex + 1000
    }
  },
  watch: {
    showAi() {
      if (this.visibleSlideBar) return
      localStorage.setItem('custom', 'false')
      this.handleClickEnterAiHelper()
      setTimeout(() => {
        this.isMoveAIIcon = false
      })
      document.body.setAttribute('style', 'cursor: default;')
    },
    '$route.path': {
      handler(val) {
        // 没有 AI 助手权限的用户不需要拉快捷键
        if (!this.getAuthorityShowAI) return
        if (
          this.notRouters.indexOf(val) === -1 &&
          !!this.$store.getters.token
        ) {
          this.getEnableModels()
          if (this.hotkeysConflictSettings.length < 1) {
            this.initHotkeys()
          }
        }
      },
      deep: true
    },
    visibleFullScreen(val) {
      if (val) {
        this.getEnableModels()
      }
    }
  },
  created() {
    eventBus.$on('externalSend', this.externalSend)
    eventBus.$on('aiOpen', this.aiOpen)
    eventBus.$on('aiVideoExtractOpen', this.aiVideoExtractOpen)
    eventBus.$on('useAi', this.useAi)
    // 监听浏览器后退事件
    window.addEventListener('popstate', this.onPopState)
  },
  destroyed() {
    eventBus.$off('externalSend', this.externalSend)
    eventBus.$off('aiOpen', this.aiOpen)
    eventBus.$off('aiVideoExtractOpen', this.aiVideoExtractOpen)
    eventBus.$off('useAi', this.useAi)
  },
  mounted() {
    localStorage.setItem('custom', 'false')
    if (this.$store.getters.token) this.setHints()
  },
  methods: {
    getPageIndex() {
      return this.pageIndex
    },
    getRealConversationId() {
      return this.real_conversation_id
    },
    async setHints() {
      const flag = localStorage.getItem('custom') === 'true'
      // const flag = false
      console.log(flag, 'flaggggg')
      const { code, data } = flag
        ? await EnableModels()
        : await getEnableModels()

      const llmDict = {}
      if (code === 1) {
        data.forEach(item => {
          // 提取llmType和modelDescribe
          const llmType = item.llmType
          const modelDescribe = item.modelDescribe

          // 将llmType作为键，modelDescribe作为值存储到字典中
          llmDict[llmType] = modelDescribe
        })

        this.Hints = llmDict
      }
    },
    // 浏览器返回控制
    onPopState() {
      if (this.visibleFullScreen) {
        const url = `${window.location.origin}/#${this.$route.fullPath}`
        window.history.pushState(null, null, url)
        this.visibleFullScreen = false
      }
    },
    async resetSessionAI() {
      const ais = this.chatMessageList
      const lastMsgInfo = ais[ais.length - 1]
      lastMsgInfo.isHistory = true

      if (lastMsgInfo?.hasNew) return
      if (lastMsgInfo?.id && !lastMsgInfo?.hasNew) {
        ais[ais.findIndex(f => f.id === lastMsgInfo.id)].hasNew = true
        await conversationNew(lastMsgInfo.id)
      }

      this.setChatMessage({
        type: 'G',
        isNewChat: true,
        text: '全新的开始',
        isHistory: true,
        hasNew: true
      })
      this.setChatMessage({
        type: 'ai',
        text: `上下文已经清除，请开始你的全新对话吧！`,
        isHistory: true,
        hasNew: true
      })
    },
    // 判断文本是否包含网址且替换成a标签
    // isUrl(val) {
    //   let str = val
    //   const regex =
    //     /([^\u4e00-\u9fa5():：,!@#$%^&*?.\s-]([^\u4e00-\u9fa5()：,!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}(\/\S*)?/gi
    //   console.log('11111', regex)
    //   str = str.replace(regex, val => {
    //     const list = val.split(':')
    //     let url = val
    //     // let residue = ''
    //     if (val.includes(':')) {
    //       if (list[0] !== 'http' && list[0] !== 'https') {
    //         url = list[1]
    //         // residue = list[0] + ':'
    //       }
    //     }
    //     if (url.indexOf(')') !== -1) {
    //       url = url.substr(0, url.length - 1)
    //     }

    //     // return `${residue}<a style="color:#3A7FFF" target="_blank"  href="${url}">${url})</a>`
    //     return `<a style="color:#3A7FFF" target="_blank"  href="${url}">${url})</a>`
    //   })
    //   return str
    // },
    setAllHistoryList() {
      this.chatMessageList.forEach((item, index) => {
        if (
          (item.type === 'ai' || item.type === 'customTmp') &&
          index < this.chatMessageList.length - 1
        ) {
          item.isHistory = true
        }
      })
    },
    openCustomComponent(text) {
      const info = this.getTypeAIList.find(item => item.checked)
      const str = info.content
      const list = []
      const ignoreList = ['ImageGeneration', 'VideoExtract']
      if (
        str &&
        str.length > 0 &&
        (ignoreList.filter(f => f === info.assistantType).length < 1 || text)
      ) {
        const regex = /\【.*?\】/g
        const matches = str.match(regex)
        const count = matches ? matches.length : 0
        if (count > 0) {
          matches.forEach((item, index) => {
            list.push({
              name: 'el-input',
              value: text && index === 0 ? text : '',
              type: 'textarea',
              props: {
                maxlength: this.getIsShowDouyinBZhangGuide ? undefined : 2000,
                'show-word-limit': true,
                resize: 'none',
                class: ['custom-input'],
                autosize: { minRows: 1, maxRows: 6 },
                placeholder: item.replace(/\【/g, '').replace(/\】/g, '')
              },
              info: { ...info, headerTitle: info.title.split('')[0] }
            })
          })
        }
      }
      return list
    },
    aiVideoExtractOpen(text) {
      if (!this.isAIEnd) return
      this.$store.dispatch('ai/setAiShowType', 0)
      this.visibleFullScreen = true
      this.init('20')
      this.$nextTick(() => {
        setTimeout(() => {
          eventBus.$emit('WordExtractSend', { value: text })
        }, 1000)
      })
    },
    // 0-大屏 1-小屏
    aiOpen(type) {
      console.log(type)
      if (type === 0) {
        this.$store.dispatch('ai/setAiShowType', 0)
        this.visibleFullScreen = true
      }
      if (type === 1) {
        this.$store.dispatch('ai/setAiShowType', 1)
        this.visibleSlideBar = true
      }
      this.init()
    },
    mouseupIcon(e) {
      this.$store.dispatch('ai/setChatValue', '')
      localStorage.setItem('custom', 'false')
      if (this.oldX === e.clientX && this.oldY === e.clientY) {
        this.handleClickEnterAiHelper()
      }
      setTimeout(() => {
        this.isMoveAIIcon = false
      })
      document.body.setAttribute('style', 'cursor: default;')
      // document.getElementById('aiSideId').style.right = undefined
      // document.removeEventListener('mousemove', this.setStyleAI)
      // document.removeEventListener('mouseup', this.mouseupIcon)
    },
    mousedownIcon(e) {
      this.oldY = e.clientY
      this.oldX = e.clientX
      // document.getElementById('aiSideId').style.top = this.oldY
      // document.addEventListener('mousemove', this.setStyleAI)
      // document.addEventListener('mouseup', this.mouseupIcon)
    },
    // setStyleAI(e) {
    //   if (Math.abs(e.clientY - this.oldY) < 1) return
    //   this.isMoveAIIcon = true
    //   document.getElementById('aiSideId').style.bottom = 'initial'
    //   document.body.setAttribute('style', 'cursor: move;')
    //   document.getElementById('aiSideId').style.top =
    //     e.clientY < 50
    //       ? '55px'
    //       : e.clientY > document.body.clientHeight - 40
    //         ? document.body.clientHeight - 40 + 'px'
    //         : e.clientY + 'px'
    // },
    setModelLlm(llmLIst) {
      const currentLlm = llmLIst.find(f => f.isSelect)
      let result = []
      if (currentLlm) {
        result = llmLIst
      } else {
        result = llmLIst.map((f, i) => ({
          ...f,
          isSelect: i === 0
        }))
      }
      return result
    },
    getEnableModels() {
      const getLocalModelType = localStorage.getItem(
        'modelTypeAIv1.2.3' + this.$store.getters.userInfo.userId
      )
      const getLocalModelTypeCustom = localStorage.getItem(
        'modelTypeAIv1.2.3_custom' + this.$store.getters.userInfo.userId
      )

      setTimeout(() => {
        if (localStorage.getItem('custom') === 'true') {
          EnableModels().then(res => {
            this.modelList = this.setModelLlm(
              res.data.map((m, i) => ({
                ...m,
                isSelect: getLocalModelTypeCustom
                  ? m.llmType === Number(getLocalModelTypeCustom)
                  : i === 0
              })) || []
            )

            this.modelType = this.modelList.find(f => f.isSelect)
              ? this.modelList.find(f => f.isSelect).llmType
              : null
          })
        } else {
          getEnableModels().then(res => {
            this.modelList = this.setModelLlm(
              res.data.map((m, i) => ({
                ...m,
                isSelect: getLocalModelType
                  ? m.llmType === Number(getLocalModelType)
                  : i === 0
              })) || []
            )

            this.modelType = this.modelList.find(f => f.isSelect)
              ? this.modelList.find(f => f.isSelect).llmType
              : null
          })
        }
      }, 200)
    },
    getNewsList() {
      return this.newsList
    },
    setNewsList(list) {
      this.newsList = list
    },
    getModelList() {
      return this.modelList
    },
    getModelType() {
      return this.modelType
    },
    async setModelType(type, index) {
      console.log(type)
      this.thinkList = ''
      clearInterval(this.intervalAI)
      if (
        this.modelList.find(f => f.isSelect).llmType ===
        this.modelList[index].llmType
      ) {
        return
      }
      const pointObj = {
        2: () => {
          this.$uweb && this.$uweb.setAction('Event_model_change_GPT4')
        },
        3: () => {
          this.$uweb && this.$uweb.setAction('Event_model_change_xinhuo')
        },
        4: () => {
          this.$uweb && this.$uweb.setAction('Event_model_change_Claude2')
        },
        9: () => {
          this.$uweb && this.$uweb.setAction('Event_Model_Toogle_WenXin')
        },
        10: () => {
          this.$uweb && this.$uweb.setAction('Event_Model_Toogle_KIMI')
        }
      }
      pointObj[type] && pointObj[type]()

      if (localStorage.getItem('custom') === 'true') {
        localStorage.setItem(
          'modelTypeAIv1.2.3_custom' + this.$store.getters.userInfo.userId,
          type
        )
      } else {
        localStorage.setItem(
          'modelTypeAIv1.2.3' + this.$store.getters.userInfo.userId,
          type
        )
      }

      this.modelList.forEach((m, i) => {
        if (i === index) {
          m.isSelect = true
        } else {
          m.isSelect = false
        }
      })
      const ais = this.chatMessageList
      const lastMsgInfo = ais[ais.length - 1]
      lastMsgInfo.isHistory = true

      // if (lastMsgInfo?.hasNew) return
      if (lastMsgInfo?.id && !lastMsgInfo?.hasNew) {
        ais[ais.findIndex(f => f.id === lastMsgInfo.id)].hasNew = true
        await conversationNew(lastMsgInfo.id)
      }
      this.modelType = type
      this.setChatMessage({
        type: 'G',
        text: '模型切换: ' + this.modelList[index].displayName,
        isHistory: true,
        hasNew: true,
        thinkingTxt: ''
      })
      this.setChatMessage({
        type: 'ai',
        // text: `已切换到大模型${this.modelList[index].displayName}，请开始你的全新对话吧！`,
        text: this.Hints[this.modelList[index].llmType],
        isHistory: true,
        hasNew: true,
        thinkingTxt: ''
      })
    },
    async externalSend(record) {
      if (!this.visibleSlideBar) {
        await this.init()
        this.$nextTick(() => {
          this.openSlideBar()
        })
      }
      setTimeout(() => {
        eventBus.$emit('aiSend', { ...record })
      }, 1000)
    },
    openSlideBar() {
      this.$store.dispatch('ai/setAiShowType', 1)
      this.visibleSlideBar = true
    },
    setIsAIEnd(val) {
      if (!this.globalInterval) {
        clearInterval(this.globalInterval)
        this.globalInterval = null
      }

      // 修改ai回答过的数据为历史数据状态
      this.chatMessageList.forEach((item, index) => {
        if (
          (item.type === 'ai' || item.type === 'customTmp') &&
          index < this.chatMessageList.length - 1
        ) {
          this.$set(item, 'isHistory', true)
        }
      })

      this.tmpMessage = null
      this.isAIEnd = val
    },
    getIsAIEnd() {
      return this.isAIEnd
    },
    async init(id = undefined) {
      this.clearChatMessage()
      this.real_conversation_id = ''
      this.typeAIList.length = 0
      // 在数组第一位插入我的AI助手
      // this.typeAIList.push({
      //   name: '我的AI助手',
      //   type: 'AI',
      //   icon: undefined,
      //   checked: true
      // })

      // 获取以前选中的助手
      const isScene = this.$store?.getters['ai/isScene']
      console.log(isScene, 'isScene')
      await this.getTemplatePage(id || isScene?.id)
      this.getHistory(undefined, isScene).then(res => {
        if (!res) {
          this.chatMessageList.push({
            type: 'welcome',
            hasNew: true
          })
        }
      })
    },
    setTypeAIList() {
      const isScene = this.$store?.getters['ai/isScene']
      return this.getTemplatePage(isScene?.id)
    },
    getHistory(isAddPageIndex, record, conversationId) {
      return new Promise((resolve, reject) => {
        if (isAddPageIndex) {
          this.$uweb?.setAction('Event_History_More')
          this.pageIndex++
        } else {
          this.pageIndex = 1
        }
        const tmp = this.getTypeAIList.find(item => item.checked) || record
        this.$store.dispatch('ai/setScene', tmp)

        getHistory({
          sceneId: tmp?.id,
          pageIndex: this.pageIndex,
          pageSize: 50,
          sort: 'desc',
          conversationId
        }).then(res => {
          if (res.code === 1) {
            const list = res.data
            if (list.length === 0) {
              if (!isAddPageIndex && conversationId) {
                this.clearChatMessage()
                this.chatMessageList.push({
                  type: 'welcome',
                  hasNew: true
                })
              }

              if (this.pageIndex > 1) {
                this.pageIndex--
              }
              resolve(false)
            } else {
              this.clearChatMessage()
              // hasNewList: JSON.parse(item.processResult),
              //         newsName:`已为您找到${JSON.parse(item.processResult).length}篇相关内容` ,
              //         newsList: JSON.parse(item.processResult).map((item, index) => ({
              //           id: index + 1,
              //           title: item.title || '',
              //           content: item.summary || '',
              //           url: item.url || '',
              //         })),
              list.forEach((item, i) => {
                const processResult = item.processResult
                  ? JSON.parse(item.processResult)
                  : {}
                // console.log(JSON.parse(item.processResult),'hihihihihihihihi000--0----');
                if (item.fileName) {
                  this.chatMessageList.unshift(
                    {
                      type: 'user',
                      text: item.userMsg,
                      messageType: item.fileName === '录音总结' ? '' : 'file',
                      fileExtension: item.format,
                      fileName: item.fileName,
                      fileSize: item.fileSize,
                      fileUrl: item.fileUrl,
                      format: item.format,
                      isHistory: true
                    },
                    {
                      type: 'ai',
                      text: item.assistant,
                      isHistory: true,
                      source: item.source,
                      isCollect: item.isStarred,
                      isLike: item.isLiked,
                      isNoLike: item.isDisliked,
                      tmpIsOk: true,
                      hasNew: item.hasNew,
                      thinkingTxt: item.thinkText,
                      isSendSelectedTopic: !this.isJsonArray(item.assistant),
                      id: item.conversationId,
                      news: {
                        newsName: processResult.processName,
                        newsList:
                          processResult.searchResult?.map((item, index) => ({
                            id: index + 1,
                            title: item.title || '',
                            content: item.summary || '',
                            url: item.url || ''
                          })) ?? []
                      }
                    }
                  )
                } else {
                  this.chatMessageList.unshift(
                    {
                      type: 'user',
                      text: item.user,
                      isHistory: true
                    },
                    {
                      type: 'ai',
                      text: item.assistant,
                      isHistory: true,
                      source: item.source,
                      isCollect: item.isStarred,
                      isLike: item.isLiked,
                      isNoLike: item.isDisliked,
                      tmpIsOk: true,
                      hasNew: item.hasNew,
                      thinkingTxt: item.thinkText,
                      isSendSelectedTopic: !this.isJsonArray(item.assistant),
                      id: item.conversationId,
                      hasNewList: !!processResult.processName,
                      news: {
                        newsName: processResult.processName,
                        newsList:
                          processResult.searchResult?.map((item, index) => ({
                            id: index + 1,
                            title: item.title || '',
                            content: item.summary || '',
                            url: item.url || ''
                          })) ?? []
                      }
                    }
                  )
                }
                if (i === list.length - 1) {
                  resolve(true)
                }
              })
            }
          }
        })
      })
    },
    isJsonArray(text) {
      try {
        const obj = JSON.parse(text)
        return Array.isArray(obj)
      } catch (e) {
        return false
      }
    },
    resetChatMessageListTmpIsOk() {
      this.chatMessageList.forEach((item, index) => {
        if (item.tmpIsOk) {
          this.$set(item, 'tmpIsOk', false)
        }
      })
    },
    setIsRestart(val) {
      this.isRestart = val
    },
    getIsRestart() {
      return this.isRestart
    },
    getDisabledInput() {
      return this.disabledInput
    },
    setDisabledInput(val) {
      this.disabledInput = val
    },
    setTmpMessage(record) {
      const index = this.chatMessageList.length - 1

      // 使用 this.$set 更新 conversation_id
      this.$set(
        this.chatMessageList[index],
        'conversation_id',
        record.conversation_id
      )

      if (record.type === 'processing') {
        // 如果已经有新闻列表且不为空，则跳过
        if (this.chatMessageList[index].news?.newsList?.length > 0) {
          return
        }

        const process = record.process || {}

        if (process.processName) {
          // 初始化 news 对象
          this.$set(this.chatMessageList[index], 'news', {
            newsName: process.processName,
            newsList: []
          })

          this.$set(this.chatMessageList[index], 'hasNewList', true)

          if (
            process.processData &&
            Array.isArray(process.processData.searchResult)
          ) {
            const formattedNewsList = process.processData.searchResult.map(
              (item, index) => ({
                id: index + 1,
                title: item.title || '',
                content: item.summary || '',
                url: item.url || ''
              })
            )

            this.$set(
              this.chatMessageList[index].news,
              'newsList',
              formattedNewsList
            )
          }
        }
      }

      if (record.type === 'thinking') {
        this.thinkList += record.reply
        this.textList = ''
      }

      if (!this.tmpMessage) {
        this.joinIndex = 0
        this.tmpMessage = { ...record, isEnd: true }
        this.joinStr()
      } else {
        if (this.tmpMessage.status === 'DONE') {
          return
        }
        this.$set(this.tmpMessage, 'applyType', record.applyType)
        this.$set(
          this.tmpMessage,
          'reply',
          (this.tmpMessage.reply || '') + record.reply
        )
        this.$set(this.tmpMessage, 'status', record.status)
      }
    },
    // 拼接字符串
    joinStr() {
      const iTime = 16.66 // 输出间隔时间（毫秒）
      let lastExecutionTime = 0 // 记录上次执行的时间
      let isRunning = true // 控制是否继续运行
      this.joinIndex = 0 // 初始化输出字符的索引

      const runAI = timestamp => {
        if (!isRunning) {
          return // 如果不再运行，则停止
        }

        const deltaTime = timestamp - lastExecutionTime // 计算上次执行至今的时间差

        // 检查是否达到设定的时间间隔再执行
        if (deltaTime >= iTime) {
          lastExecutionTime = timestamp // 更新上次执行时间
          const record = { ...this.tmpMessage } // 复制消息记录
          if (!record.reply || record.reply === '') {
            requestAnimationFrame(runAI) // 如果没有回复，请求下一帧
            return
          }

          const textList = record.reply.split('')

          // 如果 AI 已结束，停止处理
          if (this.isAIEnd) {
            isRunning = false // 设置为不再运行
            this.setIsAIEnd(true)
            this.setDisabledInput(false)
            this.thinkList = []
            return
          }

          // 控制字符输出
          if (this.joinIndex < record.reply.length) {
            this.setIndexChatMessage({
              ...record,
              reply: textList[this.joinIndex],
              replyThink: this.thinkList[this.joinIndex] || ''
            })
            this.joinIndex++
          }

          // 检查输出是否完成
          if (
            this.joinIndex === record.reply.length &&
            record.status === 'DONE'
          ) {
            this.chatMessageList[this.chatMessageList.length - 1].source =
              record.source
            this.chatMessageList[this.chatMessageList.length - 1].tmpIsOk = true
            const str =
              this.chatMessageList[this.chatMessageList.length - 1].text
            this.chatMessageList[this.chatMessageList.length - 1].text = str
            if (record?.real_conversation_id) {
              this.real_conversation_id = record.real_conversation_id
            }
            this.setIsAIEnd(true) // 设置结束状态
            this.setDisabledInput(false) // 启用输入框
            this.thinkList = [] // 清空思考列表
            isRunning = false // 停止运行
          }
        }

        // 请求下一帧
        requestAnimationFrame(runAI)
      }

      // 若之前有定时器，清除
      if (this.intervalAI) {
        clearInterval(this.intervalAI)
        this.intervalAI = undefined
      }

      // 启动打字机效果的循环
      requestAnimationFrame(runAI)
    },
    getWS() {
      return this.ws
    },
    // 创建websocket
    createWS() {
      return new Promise((resolve, reject) => {
        try {
          const orgInfo = JSON.parse(localStorage.getItem('orgInfo'))
          // 备选机构Id
          const orgInfoStore = JSON.parse(localStorage.getItem('store'))
          // 生成随机密钥
          const { randomKey, symmetricKey } = generatRandomKey()
          // 加密对称密钥
          const secretKey = encryptSymmetricKey(symmetricKey)
          // 加密握手码
          const handshakeCode = encryptRequestBody(
            (orgInfo?.organizationId ||
              orgInfoStore?.institution?.orgInfo.tenantId) +
              ',' +
              this.userInfo.userId,
            randomKey
          )
          const url = organConfig.VUE_APP_BASE_AI_URL

          this.ws = new WebSocket(
            `${url}/cloud/hok-ai/ws/chat/?time=${new Date().getTime()}`,
            [encodeURIComponent(secretKey), encodeURIComponent(handshakeCode)]
          )
          // 是否连接成功
          this.ws.onopen = () => {
            console.log('WebSocket success')
            this.ws_heartCheck.reset().start(this.ws)
            resolve(this.ws)
          }
          // 异常
          this.ws.onerror = event => {
            console.log(
              '%cws异常报错开始>>>>>>>>>>>>>',
              'background: red;padding:5px'
            )
            console.log(event)
            console.log(
              '<<<<<<<<<<<<<<<<<<%cws异常报错结束',
              'background: red;padding:5px'
            )
            const orgInfo = JSON.parse(localStorage.getItem('orgInfo'))
            const data = {
              eventStr: JSON.stringify(event, [
                'message',
                'arguments',
                'type',
                'name'
              ]),
              tenantId: orgInfo.organizationId,
              userId: this.userInfo.userId
            }
            // 上报错误日志
            wsOnErrorEvent(data)

            this.setIsAIEnd(true)
            if (this.chatMessageList.length > 0) {
              const info = this.chatMessageList[this.chatMessageList.length - 1]
              if (
                info.type === 'ai' &&
                !info.isHistory &&
                info.status === 'PENDING'
              ) {
                this.chatMessageList[this.chatMessageList.length - 1].text =
                  'AI连接异常，请重新提问！'
                this.chatMessageList[this.chatMessageList.length - 1].status =
                  'close'
                this.disabledInput = false
              }
            }
            this.closeWS()
            reject()
          }
          // 关闭
          this.ws.onclose = () => {
            this.closeWS()
            console.log('WebSocket close: 关闭连接/断开连接')
          }
        } catch (err) {
          reject()
          console.log(err, 'err')
        }
      })
    },
    closeWS() {
      this.ws_heartCheck.reset()
      this.ws && this.ws.close()
    },
    getColor() {
      return this.colors[Math.floor(Math.random() * this.colors.length)]
    },

    sortByDateDescending(arr) {
      return arr.sort((a, b) => {
        const dateA = new Date(a.topTime)
        const dateB = new Date(b.topTime)
        return dateB - dateA // 降序排序
      })
    },
    // 获取模板列表
    getTemplatePage(id) {
      return getMyAssistantUsedList({
        pageIndex: 1,
        pageSize: 1000000
        // isDeleted: 1
      }).then(res => {
        res.data.items.unshift(this.aiZhiyun)
        console.log(res, 'res+++++++++++++++')
        if (res.code === 1 && res.data.items.length > 0) {
          res.data.items.map(v => {
            v.id = v.templateId
            v.describe = v.description
            v.createNickName = v.createdNickName
            v.useCount = v.useCounter
            v.isDeleted =
              v.isDeleted ||
              (v.isPrivate && v.createdUserId !== this.userInfo.userId)
                ? 1
                : 0
          })
          const obj = {
            10: 'VideoExtract',
            11: 'ImageGeneration',
            14: 'Hotspot',
            20: 'WordExtract',
            21: 'EMOVideo'
          }
          this.typeAIList.length = 0
          const list = res.data.items.slice(1)
          const newlist = this.sortByDateDescending(list) || []
          // 判断
          const copyList = [res.data.items[0], ...newlist]
          this.typeAIList.push(
            ...copyList.map(item => ({
              ...item,
              name: item.title,
              icon: item.icon,
              type: item.id === '1' ? 'AI' : item.id,
              checked: id ? id === item.id : item.id === '1',
              assistantType: obj[Number(item.id)]
                ? obj[Number(item.id)]
                : 'systems'
            }))
          )
        }
      })
    },

    clearChatMessage() {
      this.chatMessageList.length = 0
      this.setIsRestart(false)
    },
    // 通过下标删除聊天消息对象
    removeChatMessageItem(index, number) {
      this.chatMessageList.splice(index, number)
    },
    // 通过下标修改聊天消息对象 -自定义修改字段
    setIndexChatCustomKeyMessage(key, index, data) {
      this.chatMessageList[index][key] = data
    },
    // 通过下标修改聊天消息对象 -专用于ai回答写入
    setIndexChatMessage(data) {
      const index = this.chatMessageList.length - 1

      // 使用 this.$set 更新状态和ID
      this.$set(this.chatMessageList[index], 'status', data.status)
      this.$set(this.chatMessageList[index], 'id', data.conversation_id)

      // 更新思考过程文本
      const currentThinkingTxt = this.chatMessageList[index].thinkingTxt || ''
      this.$set(
        this.chatMessageList[index],
        'thinkingTxt',
        currentThinkingTxt + data.replyThink
      )

      // 根据不同类型处理回答内容
      if (data.applyType === 'thinking') {
        this.textList = ''
        this.$set(this.chatMessageList[index], 'text', '')
      } else {
        // 正常回答内容
        if (data.conversation_id.length > 10) {
          const len1 = this.thinkList.length
          const len2 = this.chatMessageList[index].thinkingTxt?.length || 0

          // 只有当思考过程长度相等时才追加回答内容
          if (len1 === len2) {
            // 第一次长度相等时跳过，因为这时的reply还是思考文本的最后一个字符
            if (this.textList === '') {
              this.textList = data.reply
              return
            }
            const currentText = this.chatMessageList[index].text || ''
            this.$set(
              this.chatMessageList[index],
              'text',
              currentText + data.reply
            )
          }
        }
      }

      // 处理 markdown 内容的显示
      // this.$nextTick(() => {
      //   const dom = document.querySelectorAll('.text-content .markdown-body')
      //   const dom2 = dom[dom.length - 1]
      //   if (dom2) {
      //     const firstP = dom2.querySelector('div:first-child > p:first-child')
      //     const allP = dom2.querySelectorAll('div:first-child > p').length
      //     if (allP > 1 && firstP) {
      //       firstP.style.display = 'none' // 隐藏第一个段落
      //     }
      //   }
      // })
    },
    // 新增聊天消息
    setChatMessage(data) {
      this.chatMessageList.push(data)
    },
    getIsFullScreen() {
      return this.visibleFullScreen
    },
    async initHotkeys() {
      const data = await getShortcutKeys()
      this.hotkeysConflictSettings.push({
        key: data['videoExport'],
        routePath: '/videoEditor',
        // 是否优先
        isFirst: true
      })
      hotkeys('ctrl+m', e => {
        e.preventDefault()
        if (this.visibleSlideBar) return
        // 打印当前路由
        const isData = this.hotkeysConflictSettings.find(
          f => f.routePath === this.$route.path && f.key === 'Ctrl+M'
        )
        if (isData && isData.isFirst) return

        this.$uweb && this.$uweb.setAction('Event_sidebar_shortcut_keys_open')
        this.init()
        this.$store.dispatch('ai/setAiShowType', 1)
        this.visibleSlideBar = true
      })
      hotkeys('ctrl+shift+m', e => {
        e.preventDefault()
        if (this.visibleFullScreen) return
        // 打印当前路由
        const isData = this.hotkeysConflictSettings.find(
          f => f.routePath === this.$route.path && f.key === 'Ctrl+SHIFT+M'
        )
        if (isData && isData.isFirst) return
        this.$uweb &&
          this.$uweb.setAction('Event_full_screen_shortcut_keys_open')
        this.init()
        this.$store.dispatch('ai/setAiShowType', 0)
        this.visibleFullScreen = true
      })
    },

    async handleClickEnterAiHelper() {
      localStorage.setItem('custom', 'false')
      if (this.isMoveAIIcon) return
      this.setNewsList([])
      this.$uweb && this.$uweb.setAction('Event_mouse_click_open_sidebar')
      await this.$store.dispatch('user/viewingFlag', 'aigcAssistant')
      document.body.parentNode.style.overflowY = 'hidden'
      const aiShowType = this.$store?.getters['ai/aiShowType']
      this.aiOpen(aiShowType)
    },
    activeFullScreen() {
      this.$uweb && this.$uweb.setAction('Event_sidebar_click_full_screen_btn')
      this.disabledInput = false
      this.$store.dispatch('ai/setAiShowType', 0)
      this.visibleFullScreen = true
      document.body.parentNode.style.overflowY = 'hidden'
    },
    closeFullScreen() {
      this.$store.dispatch('ai/setAiShowType', 1)
      this.disabledInput = false
      this.visibleSlideBar = true
      this.visibleFullScreen = false
      this.$store.dispatch('ai/setChatValue', '')
    },
    closeSlideBar() {
      this.setIsAIEnd(true)
      this.setIsRestart(false)
      this.disabledInput = false
      this.visibleSlideBar = false
      document.body.parentNode.style.overflowY = 'auto'
      this.$store.dispatch('ai/setChatValue', '')
    },
    closeALL() {
      this.$uweb && this.$uweb.setAction('Event_close_btn')
      if (this.ws) {
        this.ws.close()
      }
      this.setIsAIEnd(true)
      this.setIsRestart(false)
      this.disabledInput = false
      this.visibleFullScreen = false
      this.visibleSlideBar = false
      document.body.parentNode.style.overflowY = 'auto'
    },
    closeAI(e) {
      e.stopPropagation()
      this.setIsAIEnd(true)
      this.setIsRestart(false)
      this.showAI = false
    },
    // 使用AI(其他页面用)
    useAi(id = '1') {
      if (!this.isAIEnd) return
      this.$store.dispatch('ai/setAICenter', false)
      this.$store.dispatch('ai/setAiShowType', 0)
      this.visibleFullScreen = true
      this.init(id)
    },
    // 使用AI(助手中心用)
    useAssistant(id = '1') {
      if (!this.isAIEnd) return
      if (this.$refs.fullScreen) {
        this.$refs.fullScreen.useAssistant(id)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ai-helper-container {
  .express-entrance {
    position: fixed;
    bottom: 140px;
    box-shadow: 0 5px 25px #0000000a, 0 3.2px 12px #00000014;
    background-color: #fff;
    width: 130px;
    height: 37px;
    box-shadow: 0px 3px 6px 0px rgba(6, 62, 155, 0.2);
    right: -100px;
    z-index: 2000;

    .entrance-item {
      position: relative;
      width: 100%;
      height: 100%;
      .icon,
      .hovericon {
        width: 44px;
        height: 44px;
        position: absolute;
        left: -12px;
        top: -3px;
        -webkit-user-drag: none; /* Safari */
        -khtml-user-drag: none; /* Konqueror */
        -moz-user-drag: none; /* Firefox */
        -o-user-drag: none; /* Opera */
        user-drag: none;
      }
      .hovericon {
        display: none;
      }
      .hover-close {
        display: none;
        position: absolute;
        top: -16px;
        left: -8%;
        color: rgba(0, 0, 0, 0.5);
        font-size: 20px;
      }
    }
  }
  .express-entrance-hover {
    &:hover {
      right: 0;
      transition: all 0.5s;
      background: linear-gradient(163deg, #3a86ff 0%, #3a86ff 2%, #3975ff 100%);
      .entrance-item {
        user-select: none;
        .icon {
          display: none;
        }
        .hovericon {
          display: block;
        }

        .hover-close {
          display: block;
        }

        &:after {
          content: '伏羲云AI助手';
          position: absolute;
          left: 40px;
          top: 7.5px;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #fff;
        }
      }
    }
  }
  .hideAfter {
    cursor: move;
    background: linear-gradient(
      163deg,
      #3a86ff 0%,
      #3a86ff 2%,
      #3975ff 100%
    ) !important;
    right: 0px !important;
    .entrance-item {
      user-select: none;
      .icon {
        display: none;
      }
      .hovericon {
        display: block;
      }

      &:after {
        content: '伏羲云AI助手';
        position: absolute;
        left: 40px;
        top: 7.5px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #fff;
      }
    }
  }
}
.slideBar-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 432px;
  height: 100%;
  background: #f9f9f9;
  border-left: 1px solid #eee;
  box-shadow: -6px 0px 31px 0px rgba(0, 0, 0, 0.2);
  z-index: 2000;
}
.ai-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 8000;
}
</style>
